import React from "react";
import ToggleSwitch from "../../forms/baseFields/toggleSwitch";
import { ToggleProps } from "models/propTypes/wintFormPropsTypes";

function Toggle(props: ToggleProps) {
  const onChange = (e: React.ChangeEvent<any>, checked: boolean) => {
    props.setValue(checked);
    props.setTouched(true, false);
  };

  return (
    <ToggleSwitch
      checked={!!props.value}
      name={props.name}
      onChange={onChange}
      onBlur={props.onBlur}
      disabled={props.disabled}
      customLabels={props.customLabels}
      data-testid={`${props.name}Toggle`}
    />
  );
}

export default Toggle;
